'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Roles$SingleRole(code) {
  this.E0 = null;
  this.E0 = code;
}
export { $c_Lpresto_types$Roles$SingleRole as $c_Lpresto_types$Roles$SingleRole };
$p = $c_Lpresto_types$Roles$SingleRole.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Roles$SingleRole;
/** @constructor */
function $h_Lpresto_types$Roles$SingleRole() {
}
export { $h_Lpresto_types$Roles$SingleRole as $h_Lpresto_types$Roles$SingleRole };
$h_Lpresto_types$Roles$SingleRole.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$Roles$SingleRole) && (this.E0 === x$0.E0)));
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "SingleRole";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.E0;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.l = (function() {
  return this.E0;
});
$p.SO = (function(tk) {
  return tk.cIQ(this.E0);
});
function $isArrayOf_Lpresto_types$Roles$SingleRole(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k4)));
}
export { $isArrayOf_Lpresto_types$Roles$SingleRole as $isArrayOf_Lpresto_types$Roles$SingleRole };
var $d_Lpresto_types$Roles$SingleRole = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Roles$SingleRole, "presto.types$Roles$SingleRole", ({
  k4: 1,
  k3: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Roles$SingleRole as $d_Lpresto_types$Roles$SingleRole };
//# sourceMappingURL=presto.types$-Roles$-Single-Role.js.map
